import createIcon from '../../createIcon';

/**
 * @component @name Keyboard
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNUg0QzIuOSA1IDIuMDEgNS45IDIuMDEgN0wyIDE3QzIgMTguMSAyLjkgMTkgNCAxOUgyMEMyMS4xIDE5IDIyIDE4LjEgMjIgMTdWN0MyMiA1LjkgMjEuMSA1IDIwIDVaTTExIDhIMTNWMTBIMTFWOFpNMTEgMTFIMTNWMTNIMTFWMTFaTTggOEgxMFYxMEg4VjhaTTggMTFIMTBWMTNIOFYxMVpNNyAxM0g1VjExSDdWMTNaTTcgMTBINVY4SDdWMTBaTTE2IDE3SDhWMTVIMTZWMTdaTTE2IDEzSDE0VjExSDE2VjEzWk0xNiAxMEgxNFY4SDE2VjEwWk0xOSAxM0gxN1YxMUgxOVYxM1pNMTkgMTBIMTdWOEgxOVYxMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Keyboard = createIcon('Keyboard', [
  [
    'path',
    {
      d: 'M20 5H4C2.9 5 2.01 5.9 2.01 7L2 17C2 18.1 2.9 19 4 19H20C21.1 19 22 18.1 22 17V7C22 5.9 21.1 5 20 5ZM11 8H13V10H11V8ZM11 11H13V13H11V11ZM8 8H10V10H8V8ZM8 11H10V13H8V11ZM7 13H5V11H7V13ZM7 10H5V8H7V10ZM16 17H8V15H16V17ZM16 13H14V11H16V13ZM16 10H14V8H16V10ZM19 13H17V11H19V13ZM19 10H17V8H19V10Z',
      key: '1aq8kk',
    },
  ],
]);

export default Keyboard;
